import React from 'react';
import PropTypes from 'prop-types';
import styles from './Badge.module.css';
import * as FaIcons from 'react-icons/fa';
import * as BsIcons from 'react-icons/bs';

const Badge = ({
  children,
  variant = 'neutral',
  size = 'md',
  icon,
  showIcon = true,
  className = '',
  ...rest
}) => {
  const badgeClasses = [
    styles.badge,
    styles[variant],
    styles[size],
    className
  ].filter(Boolean).join(' ');

  const getDefaultIcon = () => {
    switch (variant) {
      case 'success':
        return <FaIcons.FaCheckCircle />;
      case 'warning':
        return <FaIcons.FaExclamationCircle />;
      case 'error':
        return <FaIcons.FaTimesCircle />;
      case 'info':
        return <FaIcons.FaInfoCircle />;
      case 'archived':
        return <BsIcons.BsArchive />;
      default:
        return null;
    }
  };

  const displayIcon = icon || (showIcon && getDefaultIcon());

  return (
    <span className={badgeClasses} {...rest}>
      {displayIcon && <span className={styles.icon}>{displayIcon}</span>}
      <span className={styles.content}>{children}</span>
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'neutral', 'archived']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  icon: PropTypes.node,
  showIcon: PropTypes.bool,
  className: PropTypes.string,
};

export default Badge;
